<template>
  <v-container grid-list-md page>
    <v-flex>
      <v-layout row wrap>
        <v-flex xs12 sm4 md3>
          <img v-if="recommendedData.main_large_image != null" :src="recommendedData.main_large_image" alt="" width="100%">
        </v-flex>
        <v-flex xs12 sm8 md9>
          <v-jumbotron color="grey lighten-4" height="auto">
            <v-container fill-height>
              <v-layout align-center>
                <v-flex>
                  <h1 class="title mb-3">{{ recommendedData.name }}</h1>
                  <p v-html="recommendedData.main_comment"></p>
                  <v-divider class="my-3"></v-divider>
                  <v-dialog v-model="dialog" persistent max-width="400" v-if="!$store.getters.customerModulePlayListCommit">
                    <v-btn slot="activator" color="info" dark @click="dialog = true">
                      <v-icon left dark>playlist_add</v-icon>
                      プレイリストに適用
                    </v-btn>
                    <v-card>
                      <v-card-title class="headline">プレイリストに適用</v-card-title>
                      <v-card-text>適用を押すと現在のプレイリストを上書きしてこのプレイリストの内容が入ります。よろしければ適用ボタンを押してください。</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click.native="dialog = false">キャンセル</v-btn>
                        <v-btn color="primary" flat @click="applyPlayList(recommendedData.playlist_id)">適用</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-container>
          </v-jumbotron>
        </v-flex>
      </v-layout>

      <v-divider class="my-3"></v-divider>

      <RecommendedList ref="recommendedList" :playlistProducts="this.recommendedDataProducts"/>
    </v-flex>
  </v-container>
</template>

<script>
import RecommendedList from '@/components/RecommendedList.vue'
import PlayListService from '@/components/services/PlayListService.vue'
export default {
  name: 'RecommendedDetail',
  data () {
    return {
      dialog: false,
      recommendedData: {},
      recommendedDataProducts: {}
    }
  },
  components: {
    RecommendedList
  },
  created () {
    this.recommendedData.playlist_id = this.$route.params.id
    this.getRecommendPrayList(this.recommendedData.playlist_id)
  },
  methods: {
    /**
     * お勧めプレイリストＩＤを使用してプレイリストの情報を取得
     **/
    getRecommendPrayList (playListId) {
      this.logging('methods: getRecommendPrayList()')
      var transactionid = this.$store.state.transactionId
      PlayListService.findRecommendPlayList(playListId, transactionid, (response) => {
        this.recommendedData = response
        this.recommendedDataProducts = response['playlist_products']
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * おすすめプレイリストを進行プレイリストに適用する
     **/
    applyPlayList (playListId) {
      this.logging('methods: applyPlayList()')
      let formData = new URLSearchParams()
      formData.append('playlist_id', playListId)
      formData.append('transactionid', this.$store.state.transactionId)
      PlayListService.applyRecommendPlayList(formData, (response) => {
        this.logging(response)
        this.dialog = false
        this.$router.push({path: '/home/playlist'})
      }, (error) => {
        this.logging(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/recommended/RecommendedDetail.vue